var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.decideComponent,_vm._g({tag:"Component",class:_vm.variantCls.root,attrs:{"href":_vm.href,"to":_vm.to,"target":_vm.target,"disabled":_vm.disabled,"tabindex":"0"}},_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }